export const portugeuseMessages = {
	en: 'English',
	he: 'עברית',
	pt: 'Português',
	es: 'Espanhol',
	it: 'Italiano',
	PROFILE_IMAGE: 'Imagem de perfil',
	NAME: 'Nome',
	PRICE: 'Preço',
	SEARCH: 'Pesquisa',
	IS_READ: 'IsRead',
	DATE: 'Data',
	DASHBOARD_WELCOME: 'Boas-vindas ao painel',
	DASHBOARD: 'Painel',
	MONTHLY_REVENUE: 'Receita mensal',
	NEW_ORDERS: 'Novos pedidos',
	MONTH_HISTORY: 'Os usuários ingressaram nos últimos 30 dias',
	VEHICLE_COLORS: 'Cores de veículo',
	LEADS: 'Clientes potenciais',
	FROM_DATE: 'Data inicial',
	TO_DATE: 'Data final',
	GENDER: 'Gênero',
	FULL_NAME: 'Nome completo',
	HAS_CREDIT: 'Tem crédito?',
	BUDGET: 'Orçamento',
	TOTAL: 'Total',
	VEHICLE_COLOR: 'Cor do veículo',
	FROM_CREATED_AT: 'De',
	TO_CREATED_AT: 'Até',
	COACH_FOLLOWUP: 'Acompanhamento do Coach',
	COACH_FOLLOWUPS: 'Acompanhamentos do Coach',
	ORGANIZATION_NOTIFICATION: 'Notificação da organização',
	ORGANIZATION_NOTIFICATIONS: 'Notificações da organização',
	DAY_IN_MONTH: 'Dia do mês',
	NUMBER_OF_DAYS_SINCE_CLIENT_START: 'Dias desde o início do processo',
	BODY: 'Contente',
	TRAINEE: 'Alunos',
	TRAINEES: 'Alunos',
	TRAINING_MENUS: 'Arquivos de nutrição',
	COACH: 'Treinador',
	COACHES: 'Treinadores',
	PORTUGEUSE: 'Portuguese',
	RECIPE_CATEGORY: 'Categoria de receitas',
	RECIPE_CATEGORIES: 'Categorias de receitas',

	RECIPE: 'Receita',
	RECIPES: 'Receitas',

	TAG: 'Tag',
	TAGS: 'Tags',

	PRODUCT: 'Produto',
	PRODUCTS: 'Produtos',

	PRODUCT_CATEGORY: 'Categoria de produto',
	PRODUCT_CATEGORIES: 'Categorias de produto',

	MARATHON: 'Maratona',
	MARATHONS: 'Maratonas',

	DYNAMIC_CARD: 'Cartão dinâmico',
	DYNAMIC_CARDS: 'Cartões dinâmicos',

	BILLBOARD: 'Outdoor',
	BILLBOARDS: 'Outdoors',

	TRAINING: 'Treino',
	TRAININGS: 'Treinos',

	LIVE_TRAINING: 'Live Training',
	LIVE_TRAININGS: 'Live Trainings',

	LIVE_TRAININGS_MESSAGE: 'Live Training Message',
	LIVE_TRAININGS_MESSAGES: 'Live Training Messages',

	START_HOUR: 'Start Hour',
	END_HOUR: 'End Hour',

	TRAINING_CATEGORY: 'Categoria de treino',
	TRAINING_CATEGORIES: 'Categorias de treino',

	SUCCESS_STORY_CATEGORY: 'Categoria de história de sucesso',
	SUCCESS_STORY_CATEGORIES: 'Categorias de história de sucesso',
	SUCCESS_STORY: 'História de sucesso',
	SUCCESS_STORIES: 'Histórias de sucesso',
	IMAGE: 'Imagem',
	DESCRIPTION: 'Descrição',
	ABOUT_ORGANIZATION: 'About Your Organization',
	Male: 'Masculino',
	Female: 'Feminino',
	FEATURED_IMAGE: 'Imagem em destaque',
	TITLE: 'Título',
	CATEGORY: 'Categoria',
	CREATED_BY: 'Criado por',
	ORGANIZATION: 'Organização',
	GALLERY: 'Galeria',
	DYNAMIC_CATEGORY_DEFAULT_IMAGE: 'Imagem padrão de categoria dinâmica',
	LOGO_IMAGE: 'Logotipo',
	MARATHONS_FLAG: 'As maratonas estão disponíveis?',
	SUCCESS_STORY_FLAG: 'Permitir que os coachs criem histórias de sucesso pelo aplicativo?',
	COACH_FOLDER_FLAG: 'Coaches folder is publicly for all trainees?',
	COACH_REMINDER_EVERY: 'Lembrar os treinadores a cada...',
	COACH_REMINDER_EVERY_TYPE: 'Período',
	TRAINEE_REMINDER_EVERY: 'Lembrar os alunos a cada...',
	TRAINEE_REMINDER_EVERY_TYPE: 'Período',
	Admin: 'Administrador',
	Regular: 'Regular',
	EQUALS: 'Igual a',
	CONTAINS: 'Contém',
	BETWEEN: 'Entre',
	Pending: 'Pendente',
	Approved: 'Aprovado',
	SMS: 'SMS',
	Email: 'E-mail',
	All: 'Todos',
	Toning: 'Tonificação muscular',
	Mass: 'Massa',
	Coach: 'Treinador',
	Trainee: 'Atleta',
	Organization: 'Organização',
	Vegetarian: 'Vegetariano',
	Hours: 'Horas',
	Days: 'Dias',
	DAY: 'Dia',
	Weeks: 'Semanas',
	Months: 'Meses',
	FEATURED_IMAGE_URL: 'URL da imagem em destaque',
	AGENDA: 'descrição',
	DURATION: 'Duração',
	PHONE: 'Telefone',
	MENU_PDF_URL: 'URL do PDF do menu',
	BIRTH_DATE: 'Data de nascimento',
	EMAIL: 'E-mail',
	HEIGHT: 'Altura',
	WEIGHT: 'Peso',
	TRAINING_TYPE: 'Tipo de treino',
	APPROVED_BY_COACH: 'Aprovado pelo treinador',
	ADDRESS: 'Endereço',
	SHOULD_RECEIVE_MOTIVATION_NOTIFICATIONS: 'Deve receber notificações de motivação',
	SHOULD_RECEIVE_WEIGHTING_REMINDER: 'Deve receber lembretes de pesagem',
	SHOULD_RECEIVE_SENDING_IMAGE_REMINDER: 'Deve receber lembretes de envio de imagem',
	SHOULD_COACH_RECEIVE_PERSONAL_MESSAGES_REMINDER: 'O treinador deve receber lembretes de mensagens pessoais',
	SHOULD_COACH_RECEIVE_TRAINEES_PROGRESS_REMINDER: 'O treinador deve receber lembretes de progresso do atleta',
	SHOULD_COACH_RECEIVE_BIRTHDAY_NOTIFICATIONS: 'O treinador deve receber notificações de aniversários',
	SHOULD_COACH_RECEIVE_NON_UPLOADERS_REMINDER: 'O treinador deve receber lembretes de uploads não realizados',
	NOTE: 'Observação',
	VIDEO: 'Vídeo',
	CARBS: 'Carboidratos',
	PROTEINS: 'Proteínas',
	LINK: 'Link',
	YOUTUBE_LINK: 'Youtube Link',
	EXTERNAL_LINK: 'External Link',
	IFRAME_URL: 'Iframe Url',
	NUMBER_OF_PARTICIPANTS: 'Número de participantes',
	TOTAL_ACTIVE_MARATHONS: 'Total de maratonas',
	TOTAL_ACTIVE_COACHES: 'Total de treinadores',
	TOTAL_ACTIVE_TRAINEES: 'Total de alunos',
	TOTAL_CLIENTS: 'Total de usuários',
	ORGANIZATION_SETTINGS: 'Configurações da organização',
	LANGUAGE: 'Idioma',
	HEBREW: 'Hebraico',
	ENGLISH: 'Inglês',
	ITALIAN: 'Italiano',
	TOTAL_COACHES_CREATED: 'alunos que se tornaram treinadores',
	SAVED_SUCCESSFULLY: 'Salvo com sucesso',
	SENT_SUCCESSFULLY: 'Enviado com sucesso',
	VERIFICATION: 'Verification code',
	VERIFICATION_CODE: 'Verification code',
	VERIFICATIONS: 'Verification codes',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_TITLE: 'Título da notificação do coach para o aluno que entrou',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_DESCRIPTION: 'Descrição da notificação do coach para o aluno que entrou',
	TRAINEE_APPROVED_NOTIFICATION_TITLE: 'Título da notificação para o aluno sobre a aprovação',
	TRAINEE_APPROVED_NOTIFICATION_DESCRIPTION: 'Descrição da notificação para o aluno sobre a aprovação',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_TITLE: 'Título da notificação para o aluno que se inscreveu na maratona/desafio',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_DESCRIPTION: 'Descrição da notificação para o aluno que se inscreveu na maratona/desafio',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_TITLE: 'Título da notificação para o aluno que foi aprovado na/o maratona/desafio',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_DESCRIPTION: 'Descrição da notificação para o aluno que foi aprovado na/o maratona/desafio',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_TITLE: 'Coach approved marathon results title',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_DESCRIPTION: 'Coach approved marathon results description',
	NEW_SUCCESS_STORY_TITLE: 'New success story title',
	NEW_SUCCESS_STORY_DESCRIPTION: 'New success story description',
	SUPPORTED_LANGUAGES: 'Supported languages',
	DEFAULT_LANGUAGE: 'Default language',
	general: {
		error: 'Erro geral'
	},
	message: {
		error: 'Erro geral'
	},
	error: {
		general: 'Erro geral',
		request: {
			invalid_req_params: 'Parâmetros de solicitação inválidos'
		},
		files: {
			empty: 'Arquivo vazio/Nenhum arquivo enviado',
			unsupported_ext: 'Extensão incompatível'
		},
		auth: {
			wrong_credentials: 'Credenciais incorretas',
			not_admin: 'Não é administrador',
			not_client: 'Não é cliente',
			failed_authenticating_jwt: 'Falha na autenticação',
			not_registered: 'Não está inscrito',
			invalid_token: 'Token inválido '
		}
	},
	resources: {
		'verification': { name: 'Verification code' },
		'verifications': { name: 'Verification codes' },

		'trainee': { name: 'Trainee' },
		'trainees': { name: 'Trainees' },

		'coach': { name: 'Coach' },
		'coaches': { name: 'Coaches' },

		'recipe-category': { name: 'Recipe Category' },
		'recipe-categories': { name: 'Recipe Categories' },

		'recipe': { name: 'Recipe' },
		'recipes': { name: 'Recipes' },

		'product': { name: 'Product' },
		'products': { name: 'Products' },

		'product-category': { name: 'Product Category' },
		'product-categories': { name: 'Product Categories' },

		'marathon': { name: 'Marathon' },
		'marathons': { name: 'Marathons' },

		'dynamic-card': { name: 'Dynamic-card' },
		'dynamic-cards': { name: 'Dynamic-cards' },

		'billboard': { name: 'Billboard' },
		'billboards': { name: 'Billboards' },

		'training': { name: 'Training' },
		'trainings': { name: 'Trainings' },

		'training-category': { name: 'Training Category' },
		'training-categories': { name: 'Training Categories' },

		'success-story-category': { name: 'Success-story Category' },
		'success-story-categories': { name: 'Success-story Categories' },
		'success-story': { name: 'Success Story' },
		'success-stories': { name: 'Success Stories' },
		'vehicle-color': { name: 'Vehicle Color' },
		'lead': { name: 'Lead' }
	},
	ra: {
		action: {
			clear_input_value: 'Limpar',
			delete: 'Excluir',
			unselect: 'Cancelar seleção',
			sort: 'Classificar',
			show: 'Exibir',
			undo: 'Desfazer',
			confirm: 'Confirmar',
			bulk_actions: '%{smart_count} itens selecionados',
			list: 'Listar',
			export: 'Exportar',
			save: 'Salvar',
			create: 'Criar',
			edit: 'Editar',
			cancel: 'Cancelar',
			refresh: 'Atualizar',
			add_filter: 'Adicionar filtro',
			remove_filter: 'Remover filtro',
			back: 'Voltar'
		},
		boolean: {
			true: 'Sim',
			false: 'Não'
		},
		page: {
			list: '%{name} Listar',
			edit: '%{name} #%{id}',
			show: '%{name} #%{id}',
			empty: 'Sem resultados',
			invite: 'Esperamos ter dados em breve',
			create: 'Criar %{name}',
			delete: 'Excluir %{name} #%{id}',
			dashboard: 'Painel',
			not_found: 'Não encontrado',
			error: 'Erro'
		},
		input: {
			references: {
				single_missing: 'Ausente'
			},
			file: {
				upload_several:
					'Arraste e solte arquivos ou clique para carregar.',
				upload_single: 'Arraste e solte arquivos ou clique para carregar.'
			},
			image: {
				upload_several:
					'Arraste e solte arquivos ou clique para carregar.',
				upload_single:
					'Arraste e solte arquivos ou clique para carregar.'
			}
		},
		message: {
			error: 'Ops... Ocorreu um erro',
			invalid_form: 'Formulário inválido',
			yes: 'Sim',
			no: 'Não',
			are_you_sure: 'Tem certeza?',
			about: 'Sobre',
			not_found:
				'Você inseriu o URL errado ou navegou de forma incorreta',
			delete_title: 'Excluir',
			delete_content: 'Tem certeza que deseja excluir?',
			bulk_delete_title: 'Observação!',
			bulk_delete_content: 'Tem certeza de que deseja excluir TODAS as unidades?'
		},
		navigation: {
			no_results: 'Não foi possível encontrar resultados',
			page_rows_per_page: 'Linha por página',
			skip_nav: 'Ignorar',
			page_out_of_boundaries: 'Página fora dos limites',
			page_out_from_end: 'Página do final',
			page_out_from_begin: 'Página do início',
			page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
			next: 'Avançar',
			prev: 'Anterior'
		},
		auth: {
			username: 'Nome de usuário',
			password: 'Senha',
			sign_in: 'Iniciar sessão',
			sign_in_error: 'Erro ao iniciar sessão',
			logout: 'Encerrar sessão',
			auth_check_error: 'Falha na autenticação'
		},
		notification: {
			data_provider_error: 'Erro de conectividade (provedor de dados)',
			updated: 'Unidade atualizada com sucesso',
			created: 'Unidade criada com sucesso',
			deleted: 'Unidade excluída com sucesso',
			item_doesnt_exist: 'Item inexistente',
			http_error: 'Erro de conectividade (Http)'
		},
		validation: {
			required: 'Campo obrigatório',
			minLength: 'Deve conter ao menos %{min} caracteres',
			maxLength: 'Deve conter até %{max} caracteres',
			minValue: 'O valor deve ter ao menos %{min}',
			maxValue: 'O valor deve ter ao menos %{max}',
			number: 'O valor deve ser um número',
			email: 'E-mail inválido'
		}
	}
};
